import { createStyles } from '@material-ui/core';

export const inlineStyles = createStyles({
  lookupListingItem: {
    display: 'block',
    overflowX: 'hidden',
    width: '100%',
    height: 'auto',
    boxSizing: 'border-box',
    paddingLeft: '0px',
  },
  lookupListingItemNested: {
    paddingLeft: '10px'
  },
  listItemBG: {
    backgroundColor: '#BCBCBC',
    marginTop: '1px',
  },
  browseListItemBG: {
    position: 'relative',
    backgroundColor: '#CCCCCC',
    borderBottom: '1px solid #777',
    height: 'auto',
    paddingTop: '16px',
    paddingBottom: '20px',
  },
  listItemSelected: {
    backgroundColor: '#777777',
  },
  browseListItemSelected: {
    backgroundColor: '#989898'
  },
  favoriteBrowseItemIndicator: {
    position: 'absolute',
    top: 0,
    right: 0,
    borderTop: '35px solid #777777',
    borderLeft: '35px solid transparent',
    width: 0,
    height: 0,
    boxSizing: 'border-box'
  },
  favoriteStarIcon: {
    height: '15px',
    width: '15px',
    color: '#FFFFFF',
    position: 'absolute',
    top: -30,
    right: 2,
  },
  selectableListComponentStyle: {
    backgroundColor: '#999999',
    padding: 0,
    margin: 0
  },
  selectedItemStyle: {
    backgroundColor: '#777777',
  },
  browseSelectedItemStyle: {
    backgroundColor: '#989898',
  },
  preLoader: {

  },
  loadingItem: {
    padding: '7.5px 130px',
    height: '65px'
  },
  nestedListItem: {
    backgroundColor: '#BCBCBC',
    marginTop: '1px',
  },
  nestedBrowseListItemBG: {
    position: 'relative',
    backgroundColor: '#CCCCCC',
    borderBottom: '1px solid #777',
    height: 'auto',
    paddingTop: '16px',
    paddingBottom: '20px',
    paddingLeft: '45px'
  },
  nestedListExpansionIcon: {
    position: 'absolute',
    right: 0,
    top: 'calc(50% - 13px)',
    cursor: 'pointer'
  },
  listItemInner: {
    display: 'grid',
    gridTemplateColumns: '25px auto',
    alignItems: 'center',
  },
});
